const tipoPrecificacaoOrcamentoTecnicoVendaConsts = {
    direta : 1,
    painelOrcamento: 2
} 

export default tipoPrecificacaoOrcamentoTecnicoVendaConsts;